<template>
  <div>
    <Head :title="__(title)" />
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8 nick">
          
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('First name')" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Last name')" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Email')" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Phone')" />
          <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2" :label="__('City')" />
          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Address')" />
          <select-input v-model="form.country_id" :error="form.errors.country_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Country')">
            <option :value="null" />
            <option v-for="c in countries" :key="c.id" :value="c.id">{{ __(c.name) }}</option>
          </select-input>
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/3" type="password" autocomplete="new-password" :label="__('Password')" />
          
          <select-input v-model="form.department_id" :error="form.errors.department_id" :onChange="loadCategories" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Department')" :required="true">
                        <option :value="null" />
                        <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>
          
          <select-input v-model="form.category_id" :onChange="setDepCat" :error="form.errors.category_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Category')" :required="true">
                        <option :value="null" />
                        <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          
          
           <div class="w-full lg:w-1/3 shadow p-8">
             <ul>
                <h3 class="font-bold mb-3">Responsable en :</h3>
                <li class="flex justify-between mb-2" v-for="ucd in user_cat_dep_list" :id="ucd.id">
                  <div class="w-auto">{{ ucd.name }}</div>
                  <div class="w-auto">
                    <button  type="button" class="btn text-red-700 flex justify-center items-center pb-3 border-0 pl-0" @click="remove(ucd.id)">
                      {{ __('Delete') }}
                    </button>
                  </div>
                </li>
            </ul>
           </div>

           <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" :label="__('Photo')" />

        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }} {{ __('User') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
 
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    countries: Array,
    cities: Array,
    title: String,
    roles: Array,
    categories: Array,
    departments : Array,
    user_cat_dep : Array,
    user_cat_dep_list: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        city: null,
        address: '',
        country_id: null,
        role_id: null,
        password: '',
        photo: null,
        category_id: null,
        department_id  : null,
        user_cat_dep : []
      }),
    }
  },
  created() {
    // this.setDefaultValue(this.departments, 'department_id', 'Technical')
  },
  methods: {
    setDefaultValue(arr, key, value){
      const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
      if(find){
        this.form[key] = find['id']
      }
    },
    store() {
      this.form.post(this.route('users.store'))
    },
    loadCategories(e){
      this.$inertia.get(this.route('users.create', {category_id: e.target.value}), {e}, {
              preserveState: true,
              preserveScroll: true,
              replace: true
      })
    },
    remove(item){
      if (confirm('¿Esta seguro que desea borrar este registro?')) {
        for( var i = 0; i < this.form.user_cat_dep.length; i++){ 
            if ( this.form.user_cat_dep[i] == item) { 
              this.form.user_cat_dep.splice(i, 1); 
            }
        }
        this._reload();
      }
    },
     _reload(){
        this.$inertia.get(this.route('users.create', {user_cat_dep: this.form.user_cat_dep , category_id: this.form.department_id}), {}, {
                preserveState: true,
                preserveScroll: true,
                replace: true
          })
     }, setDepCat(){
        this.form.user_cat_dep.push(this.form.department_id+''+this.form.category_id);
        this._reload();
    }
  },
} 
</script>
